"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemRadio = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const menu_item_styles_1 = require("@/components/common/menu-item/menu-item.styles");
const menu_item_utils_1 = require("@/components/common/menu-item/menu-item.utils");
const utils_1 = require("@/utils");
require("@/components/common/radio");
let MenuItemRadio = class MenuItemRadio extends (0, menu_item_utils_1.withMenuItemPresentation)(lit_1.LitElement) {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.checked = false;
        this.value = '';
        this.name = '';
        this.activate = () => {
            if (this.disabled)
                return;
            if (this.checked)
                return;
            this.checked = true;
            (0, utils_1.emit)(this, 'change', { checked: this.checked, value: this.value, name: this.name });
        };
    }
    // menu 밖(radiogroup)에서 쓰이므로 menuitemradio가 아니라 radio로 둔다.
    render() {
        return (0, menu_item_utils_1.renderMenuItemRow)({
            role: 'radio',
            disabled: this.disabled,
            ariaChecked: this.checked ? 'true' : 'false',
            onActivate: this.activate,
        }, (0, menu_item_utils_1.renderMenuItemContent)(this, this.renderAction()));
    }
    renderAction() {
        // 행(row)이 role·상태·상호작용을 소유하므로 내부 컨트롤은 시각 표시 전용(inert)이다.
        return (0, lit_1.html) `
      <mm-radio
        slot="trailing"
        inert
        aria-hidden="true"
        .name=${this.name}
        .value=${this.value}
        .checked=${this.checked}
        ?disabled=${this.disabled}
      ></mm-radio>
    `;
    }
};
MenuItemRadio.styles = [menu_item_styles_1.menuItemStyles];
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], MenuItemRadio.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], MenuItemRadio.prototype, "checked", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MenuItemRadio.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MenuItemRadio.prototype, "name", void 0);
MenuItemRadio = __decorate([
    (0, decorators_js_1.customElement)('mm-menu-item-radio')
], MenuItemRadio);
exports.MenuItemRadio = MenuItemRadio;
//# sourceMappingURL=data:application/json;base64,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